module.exports = __webpack_public_path__ + "static/media/skeleton-img.d2240af1.jpg";